import axios from "axios";
import api, { globalErrorHandler } from "../Api";

export const GET_RAFT_BY_BADGE = "GET_RAFT_BY_BADGE";
export const GET_RAFT_BY_RAFID = "GET_RAFT_BY_RAFID";
export const GET_ACADEMIC_GRADES = "GET_ACADEMIC_GRADES";
export const GET_ENGLISH_LEVEL = "GET_ENGLISH_LEVEL";
export const GET_PAYMENT_METHOD = "GET_PAYMENT_METHOD";
export const GET_POSITIONS = "GET_POSITIONS"
export const RE_LOADING = "RE_LOADING";
export const ADD_RAFT = "ADD_RAFT";
export const VALIDATION_RAFT = "VALIDATION_RAFT";
export const RE_ERROR = "RE_ERROR";
export const RE_LOADING_VALIDATION = "RE_LOADING_VALIDATION";
export const GET_LAST_REFERRALS = "GET_LAST_REFERRALS";
export const GET_LOCATIONS = "GET_LOCATIONS"
export const GET_PROMOTIONAL_CODES = "GET_PROMOTIONAL_CODES"
export const UPLOAD_FILE_RAFT = "UPLOAD_FILE_RAFT"
export const GET_SETTINGS = "GET_SETTINGS"

export const ValidationRaft = (id) => {
  const config = {
    headers: {
      'content-type': 'application/json',
    }
  }
  return async dispatch => {
    dispatch({
      type: RE_LOADING_VALIDATION
    });
    await api.get(`/api/Raft/CandidateIsValid/${id}`, config).then(res => {
      dispatch({
        type: VALIDATION_RAFT,
        data: res.data
      });

      //console.log("categoriesaction", res.data)
    })
      .catch((error) => {
        globalErrorHandler(error);
        dispatch({
          type: RE_ERROR,
          data: error.response?.data
        })
      });
  };
};

export const getAllRaft = () => {
  return async dispatch => {
    await api.get(`/api/Raft/RaftReferrerCandidateByBadge/0/100/true`).then((res => {
      dispatch({
        type: GET_RAFT_BY_BADGE,
        data: res.data
      });
    })).catch(function (error) {
      console.log("Error", error);
    });
  }
};

export const getAcademicGrades = () => {
  return async dispatch => {
    dispatch({
      type: RE_LOADING
    });
    await api.get(`${process.env.REACT_APP_API_URL}/api/Raft/GetAcademicGrades`).then((res => {
      dispatch({
        type: GET_ACADEMIC_GRADES,
        data: res.data
      });
    }))
      .catch((error) => {
        globalErrorHandler(error);
      });
  }
}

export const getLocations = () => {
  return async dispatch => {
    dispatch({
      type: RE_LOADING
    });
    await api.get(`/api/Raft/GetLocation`).then((res => {
      dispatch({
        type: GET_LOCATIONS,
        data: res.data
      });
    }))
      .catch((error) => {
        globalErrorHandler(error);
      });
  }
}

export const getPromotionalCodes = () => {
  return async dispatch => {
    dispatch({
      type: RE_LOADING
    });
    await api.get(`/api/Raft/GetPromotionalCode`).then((res => {
      dispatch({
        type: GET_PROMOTIONAL_CODES,
        data: res.data
      });
    }))
      .catch((error) => {
        globalErrorHandler(error);
      });
  }
}

export const getLastReferrals = (badge) => {
  return async dispatch => {
    if (badge == null || badge === undefined || badge === "") {
      return;
    }
    dispatch({
      type: RE_LOADING
    });
    await api.get(`${process.env.REACT_APP_API_URL}/api/Raft/GetTopMyReferals?badge=${badge}&size=3`).then((res => {
      dispatch({
        type: GET_LAST_REFERRALS,
        data: res.data
      });
    }))
      .catch((error) => {
        globalErrorHandler(error);
      });
  }
}

export const getPaymentMethod = () => {
  return async dispatch => {
    dispatch({
      type: RE_LOADING
    });
    await api.get(`${process.env.REACT_APP_API_URL}/api/Raft/GetPaymentMethods`).then((res => {
      dispatch({
        type: GET_PAYMENT_METHOD,
        data: res.data
      });
    }))
      .catch((error) => {
        globalErrorHandler(error);
      });
  }
}

export const getPositions = (location) => {
  const config = {
    headers: {
      'content-type': 'application/json',
    }
  }
  return async dispatch => {
    //  dispatch({
    //      type: RE_LOADING
    //    });
    await api.get(`/api/Raft/GetPositions/${location}`, config).then((res => {
      // var nuevoArray    = []
      // var arrayTemporal = []

      // for(var i = 0; i < res.data.length; i++) {
      //     arrayTemporal = nuevoArray.filter(resp => resp["title"] == res.data[i]["catetegory"])
      //     if(arrayTemporal.length > 0){
      //         nuevoArray[nuevoArray.indexOf(arrayTemporal[0])]["positions"].push(res.data[i]["title"])
      //     }else{
      //         nuevoArray.push({"title" : res.data[i]["catetegory"] , "positions" : [res.data[i]["title"]]})
      //     }
      // }
      //    dispatch({
      //        type: GET_POSITIONS,
      //        data: nuevoArray
      //    });

      var nuevoArray = [];
      var arrayTemporal = [];

      for (var i = 0; i < res.data.length; i++) {
        // Buscar si ya existe un objeto con el mismo "catetegory"
        arrayTemporal = nuevoArray.filter((resp) => resp["title"] === res.data[i]["catetegory"]);
        if (arrayTemporal.length > 0) {
          const index = nuevoArray.indexOf(arrayTemporal[0]);
          // Buscar si ya existe el "title" en el campo "positions"
          let positionObj = nuevoArray[index]["positions"].find((p) => p.title === res.data[i]["title"]);
          if (positionObj) {
            // Si existe, agregar el "Location" si no está ya presente
            if (!positionObj.locations.includes(res.data[i]["location"])) {
              positionObj.locations.push(res.data[i]["location"]);
            }
          } else {
            // Si no existe, agregar un nuevo objeto a "positions"
            nuevoArray[index]["positions"].push({
              title: res.data[i]["title"],
              locations: res.data[i]["location"],
            });
          }
        } else {
          // Si no existe, agregar un nuevo objeto con el título y las posiciones
          nuevoArray.push({
            title: res.data[i]["catetegory"],
            positions: [
              {
                title: res.data[i]["title"],
                locations: res.data[i]["location"],
              },
            ],
          });
        }
      }

      dispatch({
        type: GET_POSITIONS,
        data: nuevoArray,
      });


    }))
      .catch((error) => {
        globalErrorHandler(error);
      });
  }
}


export const getEnglishLevel = () => {
  return async dispatch => {
    dispatch({
      type: RE_LOADING
    });
    await api.get(`${process.env.REACT_APP_API_URL}/api/Raft/GetEnglishLevels`).then((res => {
      dispatch({
        type: GET_ENGLISH_LEVEL,
        data: res.data
      });
    }))
      .catch((error) => {
        globalErrorHandler(error);
      });
  }
}

export const getSettings = () => {
  return async dispatch => {
    dispatch({
      type: RE_LOADING
    });
    await api.get(`${process.env.REACT_APP_API_URL}/api/Raft/GetRaftSettings`).then((res => {
      dispatch({
        type: GET_SETTINGS,
        data: res.data
      });
    }))
      .catch((error) => {
        globalErrorHandler(error);
      });
  }
}

export const getByIdRaft = rafid => {
  return async dispatch => {
    dispatch({
      type: RE_LOADING
    });
    axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("jwt_token");
    await axios.get(`${process.env.REACT_APP_API_URL}/api/Raft/GetbyIdRaft?idRaft=${rafid}`).then((res => {
      dispatch({
        type: GET_RAFT_BY_RAFID,
        data: res.data
      });
    }));
  }
}

export const addRaft = (data, files) => {
  return async dispatch => {
    dispatch({
      type: RE_LOADING
    });
    const formData = new FormData();
    formData.append('badge', data.badge)
    formData.append('identificationNumber', data.identificationNumber)
    formData.append('firstName', data.firstName)
    formData.append('secondName', data.secondName)
    formData.append('lastName', data.lastName)
    formData.append('secondLastName', data.secondLastName)
    formData.append('phone', data.phone)
    formData.append('personalPhone', data.personalPhone)
    formData.append('candidateEmail', data.candidateEmail)
    formData.append('personalEmail', data.personalEmail)
    formData.append('candidateProfile', data.candidateProfile)
    formData.append('englishLevel', data.englishLevel)
    formData.append('isExternalreference', data.isExternalreference)
    formData.append('academicGrade', data.academicGrade)
    formData.append('othersDetails', data.othersDetails)
    formData.append('paymentMethod', data.paymentMethod)
    formData.append('isResumeActive', data.isResumeActive)
    formData.append('isResumeRequired', data.isResumeRequired)
    formData.append('workType', data.workType)
    formData.append('resumeUrl', data.resumeUrl)
    formData.append('promotionalCode', data.promotionalCode)
    formData.append('location', data.location)

    if (files != null) {
      formData.append('files', files)
    }
    const config = {
      headers: {
        'content-type': 'multipart/form-data',
      }
    }

    await api.post(`${process.env.REACT_APP_API_URL}/api/Raft/SaveRaft`, formData, config
    ).then((res => {
      console.log("Res", res);
      dispatch({
        type: ADD_RAFT,
        data: res.data

      });
    }))
      .catch((error) => {
        console.log("Error", error.response.data);
        globalErrorHandler(error);
        dispatch({
          type: RE_ERROR,
          data: error.response.data
        })
      });
  }
}

export const uploadFile = (file, Filename, category) => {
  return async dispatch => {
    dispatch({
      type: RE_LOADING
    });
    const formData = new FormData();
    if (file != null) {
      formData.append('file', file)
    }
    formData.append('Filename', Filename)
    formData.append('category', category)
    const config = {
      headers: {
        'content-type': 'multipart/form-data',
        'x-api-key': 'C5BFF7F0-B4DF-475E-A331-F737424F013C',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'GET, POST'
      }
    }
    await api.post(`https://middleware.foundever.com/files-api/api/File/CreateWithFolder`,
      formData, config
    ).then((res => {
      dispatch({
        type: UPLOAD_FILE_RAFT,
        data: res.data

      });
      console.log(res.data)
    }))
      .catch((error) => {
        globalErrorHandler(error);
        dispatch({
          type: RE_ERROR,
          data: error
        })
      });
  }
}

// export const getCategoriaEstudio = () => {
//   return async dispatch => {
//     dispatch({
//         type: RE_LOADING
//       });
//     axios.defaults.headers.common["Authorization"] = "Bearer " +  localStorage.getItem("jwt_token");
//     await axios.get("/api/CategoriaDeEstudio").then((res => {
//       dispatch({
//             type: GET_CATEGORIA_DE_ESTUDIO,
//             data: res.data
//         });
//     }));
// }
// }